// extracted by mini-css-extract-plugin
export var borderRadius = "_du-4";
export var large = "_du-3";
export var logoContainer = "_du-0";
export var nameLogo = "_du-2";
export var small = "_du-1";